import axios from 'axios'
import qs from "qs"
import {
	Toast
} from 'vant'
import router from '@/router'
import api from "../interface/index"
//import {Notify} from 'vant'
import {
	Dialog
} from 'vant';

let loadingCount = 0;

export const showLoading = () => {
	if (loadingCount <= 0) {
		Toast.loading({
			// mask: true,
			duration: 20000
		})
	}
	loadingCount++
}

export const hideLoading = () => {
	loadingCount--;
	if (loadingCount <= 0) {
		Toast.clear()
		loadingCount = 0
	}
};

let ssid = localStorage.getItem('ssid');

export default async (url, data, opt, isLoad = true) => {
	let lang = localStorage.getItem("lang")||"zh_hk";

	if (isLoad) {
		showLoading();
	}

	url = api.commonUrl + "/api" + url;
	const set = {
		method: 'post',
		...opt
	};
	var token = localStorage.getItem('token');
	var language = localStorage.getItem("lang");
	
	// 本地存储中已经是后端语言代码，直接使用
	let backendLanguage = language;
	return (set.method === 'post' ? axios.post(url, {
		...data,
		token,
		language: backendLanguage
	}) : axios.get(url + '?' + qs.stringify({
		...data,
		token,
		language: backendLanguage
	}))).then(r => {

		if (isLoad) {
			hideLoading();
		}

		// 检查HTTP状态码
		if (r.status === 200) {
			// 检查业务状态码
			if (r.data && (r.data.code === 1 || r.data.code === 0)) {
				return r.data;
			}
			// 如果有data但没有code，也返回（兼容某些接口）
			if (r.data) {
				return r.data;
			}
		}

		throw {
			msg: '网络错误，请稍后重试'
		};

	}).then(r => {

		if (r.code === 1) {
			return r
		} else if (r.code === 0) {
			// code: 0 表示业务提示信息，不是错误，直接返回
			return r
		} else {

			if (!r.code) {
				throw {
					msg: '网络错误，请稍后重试！'
				}
			}

			if (r.code === 406) {
				router.push('/setpaypwd');
			}

			if (r.code === 405) {
				const current = {
					...router.currentRoute
				};
				router.push('/authEmail?redirect=' + current.path+"?id="+current.query.id+"&money="+current.query.money);
			}

			if (r.code === 410) {
				router.push('/setpaypwd');
			}

			if (r.code === 403 || r.code === 401) {

				if (r.code === 401) {
					localStorage.setItem('reset_time', 0);
				}

				// 清除token和用户相关缓存
				localStorage.removeItem('token');
				localStorage.removeItem('login_username');
				localStorage.removeItem('login_password');

				const current = {
					...router.currentRoute
				};
				if (current && current.path !== '/' && !(['/', '/reg', '/forgetpwd'].includes(current
					.path))) {
					if (current.path !== '/login') {
						router.replace('/login?redirect=' + current.path)
					}
				}
			}
		}

		// 如果不是成功状态，抛出错误信息
		if (r.info) {
			throw {
				msg: r.info
			};
		} else {
			throw {
				msg: '操作失败'
			};
		}

	}).catch(r => {

		if (isLoad) {
			hideLoading();
		}

		var message = '网络错误，请稍后或更换网络重试！';

		if (r.info) {
			// 检查r.info是字符串还是对象
			if (typeof r.info === 'string') {
				message = r.info;
			} else if (typeof r.info === 'object') {
				// 如果是对象，尝试获取当前语言的错误信息
				message = r.info[lang] || r.info.zh_cn || '网络错误，请稍后重试';
			}
		}

		if (r.msg) {
			// 检查r.msg是字符串还是对象
			if (typeof r.msg === 'string') {
				message = r.msg;
			} else if (typeof r.msg === 'object') {
				// 如果是对象，尝试获取当前语言的错误信息
				message = r.msg[lang] || r.msg.zh_cn || '网络错误，请稍后重试';
			}
		}
		// if (isLoad) {
			//增加一个判断，有返回值才弹窗，防止页面未加载完按返回时提示网络错误
		if (isLoad&&(r.info||r.msg)) {
			Dialog.alert({
				message: message,
				confirmButtonText: window.vm.$i18n.t('utils.confirm')
			});
		}
		//Notify(message);

		// 不抛出空错误，避免控制台显示无意义的错误信息
		return Promise.reject(r);
	})
}
